'use client';

import React, { useEffect, useState } from 'react';
import cookie from 'react-cookies';
import type { ButtonsFactoryProps } from '@paypoteam/ui-components';
import { Modal, ModalContent, P } from '@paypoteam/ui-components';

import { env } from '@/env.mjs';

const CookieModalRO = () => {
    const [isNotificationVisible, setIsNotificationVisible] = useState(false);
    const [isCookieModalAccepted, setIsCookieModalAccepted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setIsLoading(true);
        const currentDate = new Date();

        cookie.save('pp_cookie_information', 'true', {
            secure: true,
            expires: new Date(currentDate.setMonth(currentDate.getMonth() + 1)),
        });

        setIsCookieModalAccepted(true);
        setIsNotificationVisible(false);
        setIsLoading(false);
    };

    useEffect(() => {
        const wasCookieInfoClosed = cookie.load('pp_cookie_information');

        const googleTagManager = document.createElement('script');
        const noscriptElement = document.createElement('noscript');

        googleTagManager.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NR8M2GCP');
        `;
        noscriptElement.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NR8M2GCP"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `;

        if (!wasCookieInfoClosed) {
            setIsNotificationVisible(true);
        } else {
            document.head.appendChild(googleTagManager);
            document.body.appendChild(noscriptElement);
        }

        return () => {
            googleTagManager.remove();
            noscriptElement.remove();
        };
    }, [isCookieModalAccepted]);

    const COOKIE_FOOTER_CONFIG: ButtonsFactoryProps = {
        config: [
            {
                children: 'Respingere cookie-uri non tehnice',
                onClick: () => handleClose(),
                variant: 'outline',
                disabled: isLoading,
                isLoading: isLoading,
                size: 'm',
            },
            {
                children: 'Confirmare',
                onClick: () => handleClose(),
                disabled: isLoading,
                isLoading: isLoading,
                size: 'm',
            },
        ],
        reverseOnMobile: true,
    };

    return (
        <Modal
            open={isNotificationVisible}
            onOpenChange={handleClose}
        >
            <ModalContent
                size="l"
                title="Acest site folosește cookie-uri"
                buttonsFactoryProps={COOKIE_FOOTER_CONFIG}
                isCloseButtonVisible={false}
                alignBottom
            >
                <P
                    size="xs"
                    className="text-typo-secondary"
                >
                    PayPo Plăți Amânate IFN S.A împreună cu partenerii noștri,
                    folosim cookie-uri pentru a asigura funcționarea corectă a
                    site-ului, pentru a adapta conținutul la preferințele
                    dumneavoastră și pentru a urmări statisticile. Puteți fi de
                    acord cu toate cookie-urile sau puteți utiliza site-ul
                    nostru web numai cu cele care sunt necesare pentru
                    funcționarea corectă a site-ului. Informații detaliate pot
                    fi găsite în{' '}

                    <a
                        href={`${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Politica_de_confidentialitate_si_cookies.pdf`}
                        target="_blank"
                    >
                        Politica de confidențialitate și cookies
                    </a>
                    .
                </P>
            </ModalContent>
        </Modal>
    );
};

export default CookieModalRO;
